// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// export const environment = {
//   production: false,
//   APISETTINGS: 'https://digitalqamatrix-dev.unilever.com/qmapi/',
//   tenant: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
//   clientId: '00d7abcc-2027-49d3-8d81-d9f72660fb66',
//   endpoints: 'https://digitalqamatrix-dev.unilever.com/',
//   OAUTH_TOKEN_ENDPOINT : 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/oauth2/v2.0/token',
//   DFOSBASEURL: 'https://dfos-qa.unilever.com/api/'
// };

export const environment = {
  production: false,
  APISETTINGS: 'https://digitalqamatrix-dev.unilever.com/qmapi/',
  tenant: 'f66fae02-5d36-495b-bfe0-78a6ff9f8e6e',
  clientId: '00d7abcc-2027-49d3-8d81-d9f72660fb66',
  endpoints: window.location.origin + '/',
  OAUTH_TOKEN_ENDPOINT : 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/oauth2/v2.0/token',
  DFOSBASEURL: 'https://dfos-qa.unilever.com/api/',
  msalAuthConfig: {

    auth: {

      clientId: '00d7abcc-2027-49d3-8d81-d9f72660fb66',

      authority: 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',

      validateAuthority: true,

      redirectUri: 'https://digitalqamatrix-dev.unilever.com/',

      postLogoutRedirectUri: 'https://digitalqamatrix-dev.unilever.com/',

      navigateToLoginRequestUrl: true,

    },

  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
